import { createSlice } from "@reduxjs/toolkit";


const patientSlice = createSlice({
    name: 'patient',
    initialState: {
        loading: false,
        patient: {},
        isPatientCreated: false,
        isPatientDeleted: false,
        isPatientUpdated: false,
        isFileDeleted: false
    },
    reducers: {
        patientRequest(state, action) {
            return {
                loading: true
            }
        },
        patientSuccess(state, action) {
            return {
                loading: false,
                patient: action.payload.patient
            }
        },
        patientFail(state, action) {
            return {
                loading: false,
                error: action.payload
            }
        },
        clearError(state, action) {
            return {
                ...state,
                error: null
            }
        },
        clearPatient(state, action) {
            return {
                ...state,
                patient: {}
            }
        },
        newPatientRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        newPatientSuccess(state, action) {
            return {
                ...state,
                loading: false,
                patient: action.payload.product,
                isPatientCreated: true
            }
        },
        newPatientFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload,
                isPatientCreated: false
            }
        },
        clearPatientCreated(state, action) {
            return {
                ...state,
                isPatientCreated: false
            }
        },
        deletePatientRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        deletePatientSuccess(state, action) {
            return {
                ...state,
                loading: false,
                isPatientDeleted: true
            }
        },
        deletePatientFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        },
        clearPatientDeleted(state, action) {
            return {
                ...state,
                isPatientDeleted: false
            }
        },
        updatePatientRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        updatePatientSuccess(state, action) {
            return {
                ...state,
                loading: false,
                patient: action.payload.patient,
                isPatientUpdated: true
            }
        },
        updatePatientFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        },

        deletePatientFileRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        deletePatientFileSuccess(state, action) {
            return {
                ...state,
                loading: false,
                isFileDeleted: true
            }
        },
        deletePatientFileFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        },
        clearFileDeleted(state, action) {
            return {
                ...state,
                isFileDeleted: false
            }
        },


        updateMedicalRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        updateMedicalSuccess(state, action) {
            return {
                ...state,
                loading: false,
                patient: action.payload.patient,
                isPatientUpdated: true
            }
        },
        updateMedicalFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        },

        clearPatientUpdated(state, action) {
            return {
                ...state,
                isPatientUpdated: false
            }
        }
    }
});

const { actions, reducer } = patientSlice;

export const {
    patientRequest,
    patientSuccess,
    patientFail,
    clearError,
    clearPatient,
    newPatientFail,
    newPatientRequest,
    newPatientSuccess,
    clearPatientCreated,
    deletePatientFail,
    deletePatientRequest,
    deletePatientSuccess,
    clearPatientDeleted,
    updatePatientFail,
    updatePatientRequest,
    updatePatientSuccess,
    updateMedicalRequest,
    updateMedicalSuccess,
    updateMedicalFail,
    clearPatientUpdated,
    deletePatientFileRequest,
    deletePatientFileSuccess,
    deletePatientFileFail,
    clearFileDeleted

} = actions;

export default reducer;